import { render, staticRenderFns } from "./shopcard.vue?vue&type=template&id=5d4861ba&scoped=true"
import script from "./shopcard.vue?vue&type=script&lang=js"
export * from "./shopcard.vue?vue&type=script&lang=js"
import style0 from "./shopcard.vue?vue&type=style&index=0&id=5d4861ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4861ba",
  null
  
)

export default component.exports